import React, { useContext } from "react";
import styled from "styled-components";
import { PageIntroContext } from "common/NewLook/PageIntro.context.ts";
import {
  NEW_LOOK_PAGE_GUTTER_VAR,
  NEW_LOOK_PHONE_MAX_WIDTH,
} from "common/NewLook/layout.ts";

/**
 * The new look's page toolbar: page tabs on the left and page actions on the
 * right, under the top bar (which shows the page title). Renders nothing for
 * pages without tabs or actions.
 */
const PageIntro = () => {
  const { config } = useContext(PageIntroContext);
  const { description, actions, footer, hidden } = config;

  if (hidden || (!description && !actions && !footer)) return null;

  return (
    <Wrapper>
      <Start>
        {description && <Description>{description}</Description>}
        {footer}
      </Start>
      {actions && <Actions>{actions}</Actions>}
    </Wrapper>
  );
};

export default React.memo(PageIntro);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  flex-wrap: wrap;
  padding: 16px ${NEW_LOOK_PAGE_GUTTER_VAR} 0;
  @media (max-width: ${NEW_LOOK_PHONE_MAX_WIDTH}) {
    padding: 10px 16px 0;
    gap: 8px;
  }
`;
const Start = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Description = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.secondaryText};
  font-size: 13.5px;
`;
const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
`;
